<template>
  <div>
    <b-input-group>
      <b-form-input v-model="number" data-testid="input-field" :step="step" no-wheel />
      <b-input-group-append>
        <b-button variant="outline-secondary" data-testid="increment-button" @click="number -= step">
          <i class="fas fa-minus"></i>
        </b-button>
        <b-button variant="outline-secondary" data-testid="decrement-button" @click="number += step">
          <i class="fas fa-plus"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    step: {
      type: [String, Number],
      default: 10,
    },
  },
  computed: {
    number: {
      get() {
        return this.value ? parseInt(this.value) : 0
      },
      set(newNumber) {
        const newValue = `${newNumber || 0}px`
        this.$emit('change', newValue)
      },
    },
    unit: {
      get() {
        return this.value ? this.value.replace(/^[-+]?\d+/g, '') : 'px'
      },
      set(newUnit) {
        const newValue = `${this.number}${newUnit || 'px'}`
        this.$emit('change', newValue)
      },
    },
  },
}
</script>
